export default "__VITE_ASSET__r809_93k__"